export const DialogActions = {
  UPDATE: 'update',
  CANCEL: 'cancel',
  INSERT: 'insert',
  DELETE: 'delete',
  BULK_INSERT: 'bulk_insert',
};
